/**
 * defa.collections.followMainAlarm
 * A Collection of FollowMainAlarm
 * @version 1.2.0
 */
import FollowMainAlarm from './model-follow-main-alarm';

const FollowMainAlarms = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : FollowMainAlarm,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default FollowMainAlarms;